import { quartzConfig } from 'quartz-config/evaluable';
if ( /* quartzConfig.type !== 'application' || quartzConfig.deprecated_disableOneDomain !== true */true) {
  // @ts-expect-error untyped global variable
  window.hubspot['__hub-http-labs'] = window.hubspot['__hub-http-labs'] || {};

  // @ts-expect-error untyped global variable
  window.hubspot['__hub-http-labs']['HUBONEDOMAIN'] = true;
}